export function scrollToTop() {
  document.getElementById('main')?.scrollTo(0, 0);
}
